var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":"","wrap":"","id":"customer-create"}},[_c('v-flex',{attrs:{"md6":"","xs6":""}},[_c('CreateCustomer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }